import PropTypes from 'prop-types';
import benchSvg from 'assets/img/production-output/bench.svg';
import autolineSvg from 'assets/img/production-output/autoline.svg';
import schSvg from 'assets/img/production-output/sch.svg';
import stugaSvg from 'assets/img/production-output/stuga.svg';

export const machineAssetMap = {
  bench: benchSvg,
  autoline: autolineSvg,
  sch: schSvg,
  stuga: stugaSvg
};

export const metricLabels = {
  items: 'Items scanned',
  piecesCut: 'Pieces cut/scanned',
  sashes: 'Sashes',
  boxes: 'Boxes',
  weldedCill: 'Welded cill boxes created',
  hardwareBoxes: 'Hardware boxes created',
  compositeDoorBoxes: 'Composite door boxes created'
};

export const WIDE_CARD_ENTRY_THRESHOLD = 8;

export const COMPOSITE_DOOR_GEARING_GROUP = 'Composite Door Gearing';
export const HARDWARE_PACKING_GROUP = 'Hardware Packing';
export const COMPOSITE_DOOR_PACKING_GROUP = 'Composite Door Hardware Packing';

export function formatValue(value) {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return new Intl.NumberFormat('en-GB').format(value);
}

export function getMetricLabel(metricType) {
  return metricLabels[metricType] || 'Items scanned';
}

export const breakdownItemShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  hasBoxData: PropTypes.bool,
  itemsCount: PropTypes.number,
  boxesCount: PropTypes.number,
  hasWeldedCillData: PropTypes.bool,
  weldedCillBoxesCreated: PropTypes.number,
  weldedCillTotalFacets: PropTypes.number
});

export const stationShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  stationPath: PropTypes.string,
  displayType: PropTypes.string.isRequired,
  metricType: PropTypes.string,
  isResolved: PropTypes.bool,
  resolutionNote: PropTypes.string,
  total: PropTypes.number,
  shiftBreakdown: PropTypes.arrayOf(breakdownItemShape),
  peopleBreakdown: PropTypes.arrayOf(breakdownItemShape),
  hasBoxData: PropTypes.bool,
  itemsCount: PropTypes.number,
  boxesCount: PropTypes.number,
  hasWeldedCillData: PropTypes.bool,
  weldedCillBoxesCreated: PropTypes.number,
  weldedCillTotalFacets: PropTypes.number
});

export const groupShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  displayType: PropTypes.string.isRequired,
  metricType: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  stations: PropTypes.arrayOf(stationShape).isRequired,
  shiftBreakdown: PropTypes.arrayOf(breakdownItemShape),
  peopleBreakdown: PropTypes.arrayOf(breakdownItemShape)
});

export const areaShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  groups: PropTypes.arrayOf(groupShape).isRequired,
  shiftBreakdown: PropTypes.arrayOf(breakdownItemShape),
  peopleBreakdown: PropTypes.arrayOf(breakdownItemShape)
});
